<template>
  <div class="updatelogs_content">
    <div></div>
    <div>
      <div>
        <div class="logo">
          <div>
            <router-link :to="{name:'updatelogs'}">更新日志</router-link> 
            <router-link :to="{name:'protocol'}">用户注册协议</router-link>
          </div>
        </div>
        <div class="title">
          <div>
            <span>更新日志 Update log</span>
          </div>
        </div>
      </div>
      <div>
        <ul>
          <li v-for="(log,k) in logs" :key="k">
            <div class="content">
              <div>
                {{log&&log.ctime.trim()||''}}
              </div>
              <div></div>
              <div>
                <div class="version_id">
                  {{log&&log.version_id.trim()||''}}
                </div>
                <div class="update_content" v-html="log&&log.update_content||''">

                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      logs:[]
    };
  },
  created(){
        this.$http.post('/zzVersionList').then(m=>{
            console.log(m)
            if(m.error===0){
                this.logs=m.list||[];
            }
        })
  }    
};
</script>
<style lang="scss" scoped>
@import "~@/components/layout/style/mixin.scss";
  .updatelogs_content{
    position:relative;
    background-color: #fff;
    color:  #666666;
    min-height: 800px;
    font-size: 14px;
    &>div:first-child{
      height: 100%;
      position:absolute;
      background-color:#e5e5e5;
      width: 2px;
      left: 380px;
      z-index: 1;
    }
    &>div:last-child{
      width: 100%;
      height: 100%;
      display: inline-block;
      &>div:first-child{
        text-align: left;
        position: relative;
        z-index: 2;
      .logo {
        width: 1200px;
        margin: auto;
        height: 90px;
        display: flex;
        background: #fff;
        & > div {
          display: inline-block;
          flex: 1;
          text-align: right;
          line-height: 90px;
          font-size: 15px;
          font-weight: bold;
          a {
            color: #333;
            margin-left: 40px;
            &.router-link-active {
              color: #008cd6;
            }
          }
        }
        &::before {
          content: "";
          display: inline-block;
          width: 180px;
          height: 50px;
          @include intop-icon;
          background-position: -615px -321px;
          margin-top: 20px;
        }
      }
      .title {
        background: url("~@/assets/img/about-repeat.jpg");
        height: 120px;
        & > div {
          width: 1200px;
          margin: auto;
          background: url("~@/assets/img/about.jpg") no-repeat right center;
          span {
            display: inline-block;
            vertical-align: top;
            font-size: 24px;
            color: #fff;
            line-height: 120px;
          }
          &::before {
            content: "";
            display: inline-block;
            width: 60px;
            height: 60px;
            @include intop-icon;
            background-position: -615px -247px;
            margin: 30px 10px 0 0;
          }
        }
      }
      };
      &>div:last-child{
        ul{
          list-style: none;
          li{
            &:first-child{
              .content{
                &>div:first-child{
                    color: black;
                    font-weight: bold;
                }
                &>div:nth-child(2)::after{
                  background: #008cd6;
                }
              }
            }
            .content{
              display: flex;
              flex-direction: row;
              &>div{
                &:first-child{
                  margin-top: 20px;
                  width: 300px;
                  text-align:right ;
                  margin-right: 80px;
                  color:#999999;
                };
                &:nth-child(2){
                  width: 2px;
                  background: #e5e5e5;
                  position: relative;
                  left: -40px;
                  &::after{
                    content: '';
                    display: inline-block;
                    width: 12px;
                    height: 12px;
                    border-radius: 50%;
                    background: #666666;
                    position: relative;
                    left: -5px;
                    top: -15px;
                    z-index: 3;
                  }
                  &::before{
                    content: '';
                    display: inline-block;
                    width: 30px;
                    height: 30px;
                    background: #fff;
                    position: relative;
                    left: -7px;
                    top: 15px;
                    z-index: 2;
                  }
                }
                &:last-child{
                  margin-top: 20px;
                  flex: 1;
                  text-align: left;
                  .update_content{
                    margin-top: 10px;
                    font-size: 12px;
                    white-space: pre-line;
                  }
                  .version_id{
                    color: black;
                    font-weight: bold;
                  }
                }
              }

            }
          }
        }
      }
    }
  }
</style>